import * as THREE from 'three';
import { FikoGrup } from './FikoGrup';
import { FikoVektor2D } from './FikoVektor2d';

declare var Offset: any;
// ClipperLib artık GERÇEK bağımlılık (npm clipper-lib) — eskiden global declare idi ve script hiç yüklenmiyordu:
// offsetHat sessizce offset'siz orijinal konturu döndürüyordu → takım yolu sınıra oturup r kadar DIŞARI taşıyordu (parça bozan bug).
import * as ClipperLibMod from 'clipper-lib';
const ClipperLib: any = (ClipperLibMod as any)?.default ?? ClipperLibMod;


export class Fiko2dPathSihirbaz extends FikoGrup {
    //@ts-ignore
    material = new THREE.LineBasicMaterial({ color: 0x000000 });

    sonPozisyon: FikoVektor2D = new FikoVektor2D(0, 0);
    /** NOT: Komple Yol */
    kompleYol: THREE.Shape = new THREE.Shape()
    takimYolu: THREE.Shape = new THREE.Shape()
    /** */
    geometri: THREE.BufferGeometry = new THREE.BufferGeometry();
    noktalar: FikoVektor2D[] = [];

    constructor() {
        super();
    }

    git(x: number, y: number, isim?: string): Fiko2dPathSihirbaz {
        const path = new THREE.Shape();
        path.currentPoint = this.sonPozisyon;

        path.moveTo(x, y);
        this.kompleYol.moveTo(x, y)

        this.noktalar = [...this.noktalar, ...path.getPoints()];
        this.sonPozisyon = path.currentPoint.clone();
        return this;
    }

    cizgi(x: number, y: number, isim?: string): Fiko2dPathSihirbaz {
        const path = new THREE.Shape();
        path.currentPoint.set(this.sonPozisyon.x, this.sonPozisyon.y);
        let relPoint = this.sonPozisyon.add(new FikoVektor2D(x, y));

        path.lineTo(relPoint.x, relPoint.y);
        this.kompleYol.lineTo(relPoint.x, relPoint.y);

        this.noktalar = [...this.noktalar, ...path.getPoints(32)];
        this.sonPozisyon = path.currentPoint.clone();
        return this;
    }

    egimli(bx: number, by: number, sx: number, sy: number, isim?: string): Fiko2dPathSihirbaz {
        /** HATA:  YAP:  Radiüs Yapılamadı */
        const path = new THREE.Shape();
        path.currentPoint.set(this.sonPozisyon.x, this.sonPozisyon.y);
        let basPoint = this.sonPozisyon.clone().add(new FikoVektor2D(bx, by));;

        let sonPoint = this.sonPozisyon.clone().add(new FikoVektor2D(sx, sy));
        // console.log(basPoint, sonPoint)

        path.quadraticCurveTo(basPoint.x, basPoint.y, sonPoint.x, sonPoint.y);
        this.kompleYol.quadraticCurveTo(basPoint.x, basPoint.y, sonPoint.x, sonPoint.y);

        this.noktalar = [...this.noktalar, ...path.getPoints(500)];
        this.sonPozisyon = path.currentPoint.clone();
        return this;
    }

    rad(merkezX: number, merkezY: number, radius: number, baslangicAci: number, bitisAci: number, tersSaatYonu: boolean = false) {
        const path = new THREE.Shape();
        path.currentPoint.set(this.sonPozisyon.x, this.sonPozisyon.y);

        path.arc(merkezX, merkezY, radius, baslangicAci * (Math.PI / 180), bitisAci * (Math.PI / 180), tersSaatYonu);
        this.kompleYol.arc(merkezX, merkezY, radius, baslangicAci * (Math.PI / 180), bitisAci * (Math.PI / 180), tersSaatYonu);

        this.noktalar = [...this.noktalar, ...path.getPoints(500)];
        this.sonPozisyon = path.currentPoint.clone();
        return this;
    }

    olusturGeometri(): Fiko2dPathSihirbaz {
        this.geometri.setFromPoints(this.noktalar);

        this.kompleYol = new THREE.Shape(this.noktalar);
        return this
    }

    ekleCizgi(isim?: string): Fiko2dPathSihirbaz {
        const line = new THREE.Line(this.geometri, this.material);
        line.name = isim;
        this.add(line);
        return this;
    }


    /**
     * Clipper offset hesaplama (kapalı çizgi için)
     * @param pointlist - Nokta listesi
     * @param ofst - Offset miktarı (mm)
     * @param donusTipi - Köşe tipi
     * @param isim - İsim (opsiyonel)
     */
    clipperOffset(pointlist: any, ofst: number, donusTipi?: "Keskin" | "Dairesel" | "Yakınsal", isim?: string) {
        var paths = [pointlist.map(((val: any) => { return { X: val.x, Y: val.y } }))];

        // Scale değeri tutarlılık için 10000 olarak güncellendi
        const scale = 10000;
        ClipperLib.JS.ScaleUpPaths(paths, scale)

        var co = new ClipperLib.ClipperOffset();
        var offsetted_paths = new ClipperLib.Paths(); // empty solution

        let typeJoin: any = null;
        switch (donusTipi) {
            case "Keskin":
                typeJoin = ClipperLib.JoinType.jtMiter;
                break;

            case "Yakınsal":
                typeJoin = ClipperLib.JoinType.jtSquare;
                break;

            case "Dairesel":
                typeJoin = ClipperLib.JoinType.jtRound;
                break;

            default:
                typeJoin = ClipperLib.JoinType.jtRound;
                break;
        }

        co.AddPaths(paths, typeJoin, ClipperLib.EndType.etClosedLine);
        co.MiterLimit = 2;
        co.ArcTolerance = .025;  // Daha hassas arc toleransı

        co.Execute(offsetted_paths, ofst * scale);

        // Sonucu scale ile geri bölüyoruz
        return new THREE.Shape(offsetted_paths[0].map((val: any) => { return new FikoVektor2D(val.X / scale, val.Y / scale) }));
    }
}

/**
 * Profil kapalı mı kontrol et
 * İlk ve son nokta arasındaki mesafe toleranstan küçükse kapalı sayılır
 */
const profilKapaliMi = (noktaListesi: any[], tolerans: number = 0.01): boolean => {
    if (!noktaListesi || noktaListesi.length < 3) return false;

    const ilk = noktaListesi[0];
    const son = noktaListesi[noktaListesi.length - 1];

    const dx = son.x - ilk.x;
    const dy = son.y - ilk.y;
    const mesafe = Math.sqrt(dx * dx + dy * dy);

    return mesafe < tolerans;
};

/**
 * 2D kontur offset (Clipper). ofset>0 dışa, <0 içe (kapalı poligonda).
 * kapali: true=kesin kapalı poligon (CAM cep/profil/gravür konturu — köşe listesi tekrarsız olsa bile),
 *         false=kesin açık hat, undefined=oto-tespit (ilk≈son; geriye dönük uyum).
 * GÜVENLİK: başarısızlıkta ASLA orijinal kontur döndürülmez ([] döner) — offset'siz kontur,
 * takım merkez çizgisini sınıra oturtup takım yarıçapı kadar taşma/gouge üretir (parça bozar).
 */
export const offsetHat = (noktaListesi: any, ofset: number, donusTipi: "Keskin" | "Dairesel" | "Yakınsal" = 'Dairesel', ovalTolerans: number = 0.01, kapali?: boolean) => {
    if (!ClipperLib?.JS || !ClipperLib?.ClipperOffset) {
        console.warn('[offsetHat] ClipperLib kullanılamıyor — offset üretilmedi (güvenlik: offset\'siz yol taşma yapar)');
        return [];
    }
    if (!noktaListesi || !Array.isArray(noktaListesi) || noktaListesi.length < 2) {
        console.warn('[offsetHat] Geçersiz nokta listesi');
        return [];
    }

    try {
        var paths = [noktaListesi.map(((val: any) => { return { X: val.x, Y: val.y } }))];

        var scale = 10000;
        ClipperLib.JS.ScaleUpPaths(paths, scale)

        var co = new ClipperLib.ClipperOffset();
        var offsetted_paths = new ClipperLib.Paths(); // empty solution

        let typeJoin: any = null;
        switch (donusTipi) {
            case "Keskin":
                typeJoin = ClipperLib.JoinType.jtMiter;
                break;

            case "Yakınsal":
                typeJoin = ClipperLib.JoinType.jtSquare;
                break;

            case "Dairesel":
                typeJoin = ClipperLib.JoinType.jtRound;
                break;

            default:
                typeJoin = ClipperLib.JoinType.jtRound;
                break;
        }

        // Kapalılık: açık parametre > oto-tespit (ilk≈son). CAM konturları köşe-listesi (tekrarsız) olduğundan
        // oto-tespit onları AÇIK sanır → etOpenRound iki-taraflı bant üretir (yanlış) — CAM çağrıları kapali=true geçmeli.
        const kapaliProfil = kapali !== undefined ? kapali : profilKapaliMi(noktaListesi);
        const endType = kapaliProfil
            ? ClipperLib.EndType.etClosedPolygon  // Kapalı profil için polygon
            : ClipperLib.EndType.etOpenRound;      // Açık profil için round

        co.AddPaths(paths, typeJoin, endType);
        co.MiterLimit = 2;
        co.ArcTolerance = .025;

        co.Execute(offsetted_paths, ofset * scale);

        if (!offsetted_paths || !offsetted_paths.length || !offsetted_paths[0] || offsetted_paths[0].length === 0) {
            return [];   // offset bu deltada mümkün değil (kontur eridi) — çağıran döngüsünü sonlandırır
        }

        // Çoklu sonuç (konkav içe-offset bölünmesi): en büyük |alan|lı poligonu al (ana bölge; [0] rastgele olabilir)
        let enIyi = offsetted_paths[0];
        if (offsetted_paths.length > 1) {
            let enAlan = Math.abs(ClipperLib.Clipper.Area(enIyi));
            for (let pi = 1; pi < offsetted_paths.length; pi++) {
                const a = Math.abs(ClipperLib.Clipper.Area(offsetted_paths[pi]));
                if (a > enAlan) { enAlan = a; enIyi = offsetted_paths[pi]; }
            }
        }

        return ClipperLib.JS.Lighten(enIyi, ovalTolerans * scale).map((val: any) => { return new FikoVektor2D(val.X / scale, val.Y / scale) });
    } catch (e) {
        console.warn('[offsetHat] Offset hesaplama hatası:', e);
        return [];   // güvenlik: hata → yol üretme (yanlış yol > yol yok)
    }
}